















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































// vue
import Vue from 'vue';
import { NOC, util, moment } from '@/class';
import * as NOCArray from '@/personal/array';
import utilComponents from '@/components/util';

// 部品
import WorkstyleEditer from '@/parts/setting/workstyle/WorkstyleEditer.vue';
import { strFuzzyMatch } from '@/class/common/util';

// 通信
import API from '@/api/common';
import * as models from '@/class/models/views/setting/workstyle';

// parts
import { ISelectOption } from '@/class/models/typed/wild';
import ModalMigrateConfirm from '@/components/util/ModalMigrateConfirm.vue';
import ModalDeleteConfirm from '@/components/util/ModalDeleteConfirm.vue';
import SelectBox from '@/components/util/NewSelectBox.vue';
import CheckBoxList from '@/components/util/CheckBoxList.vue';
import ModalExclusionDepartment from '@/components/util/ModalExclusionDepartment.vue';
import ModalFormDataCheck from '@/components/util/ModalFormDataCheck.vue';
import Pagination from '@/parts/app/Pagination.vue';

// validation
import * as validation from '@/personal/validation';
import {
  IVariableInput,
  INPUT_TYPE,
} from '@/components/util/VariableInput.vue';

// datepicker
import DatePicker from 'vuejs-datepicker';
import { ja } from 'vuejs-datepicker/dist/locale';

type HolidayItem = models.ICustomHoliday | models.ISpecialLeave;

interface IDispWorkstyle {
  name: '';
  workTime: '';
  restTime: '';
  holiday: string[];
  specialLeave: any[];
  customHoliday: any[];
  cutoffDay: 0;
  weekFirst: '';
  yearFirst: '';
  legalHoliday: '';
  workstyleID: 0;
  workstyle: models.IWorkstyle;
}

export default Vue.extend({
  name: 'Workstyle',
  components: {
    ...utilComponents,
    WorkstyleEditer,
    ModalMigrateConfirm,
    ModalDeleteConfirm,
    SelectBox,
    CheckBoxList,
    DatePicker,
    ModalExclusionDepartment,
    ModalFormDataCheck,
    Pagination,
  },
  props: {
    confirmDialog: Function,
  },
  watch: {
    mode() {
      this.isProcessing = false;
    },
  },
  data() {
    return {
      onload: false,
      // get data
      workstyles: [] as models.IWorkstyle[],
      specialLeaves: [] as models.ISpecialLeave[],
      specialLeaveUseds: [] as models.ISpecialLeaveUsed[],
      customHolidays: [] as models.ICustomHoliday[],
      customHolidayUseds: [] as models.ICustomHolidayUsed[],
      // select data
      selectDispWorkstyle: {} as IDispWorkstyle,
      selectDispWorkstyleUsers: [] as models.IWorkstyleUser[],
      delTargetHolidayItem: null as HolidayItem,
      delTargetCallBack: {} as () => Promise<boolean>,
      // edit data
      editWorkstyle: {} as models.IWorkstyle,
      editSpecialLeaveUseds: [] as models.ISpecialLeaveUsed[],
      editCustomHolidayUseds: [] as models.ICustomHolidayUsed[],
      compEditWorkstyle: {} as models.IWorkstyle,
      newSpecialLeave: null as models.ISpecialLeave | null,
      newCustomHoliday: null as models.ICustomHoliday | null,
      editUsers: [] as any[],
      cutoffDayType: 0,
      cutoffDay: 1,
      cutoffDayError: '',
      // table data
      optionsWorkstyle: [NOC.SELECT.ALL_WORKSTYLES] as ISelectOption[],
      migrateConfirmOptions: [NOC.SELECT.NOSELECT_LONG] as ISelectOption[],
      optionsExclusionDepartment: [] as ISelectOption[],
      tableItems: [] as any[],
      userItemCurrentDep: [] as any[],
      userItemOtherDep: [] as any[],
      compUserItemCurrentDep: [] as any[],
      tableItemsHideEmail: [] as any[],
      selectedTableFields: [
        { key: 'checked', label: '' },
        { key: 'user', sortable: true, label: '氏名' },
      ] as any[],
      tableFields: [
        { key: 'checked', label: '' },
        { key: 'workstyle', sortable: true, label: '就業形態' },
        { key: 'user', sortable: true, label: '氏名' },
      ] as any[],
      inputedSearchWorkstyle: 0,
      inputedSearchName: '',
      otherInputedSearchName: '',
      searchWorkstyle: 0,
      otherSearchWorkstyle: 0,
      searchName: '',
      otherSearchName: '',
      // items: [
      //   { key: 'workTime', label: '就業時間' },
      //   { key: 'restTime', label: '休憩時間' },
      //   { key: 'cutoffDay', label: '勤怠締め日' },
      //   { key: 'holiday', label: '休日の設定' },
      //   { key: 'customHoliday', label: 'カスタム休日' },
      // ],
      selectedDepartmentID: -1,
      items: [
        {
          key: 'name',
          name: '就業形態名',
          type: INPUT_TYPE.TEXT,
          required: true,
          error: '',
          max: 20,
        },
        {
          key: 'startTime',
          name: '始業時間',
          type: INPUT_TYPE.TIME,
          required: true,
          error: '',
          step: 900,
        },
        {
          key: 'endTime',
          name: '終業時間',
          type: INPUT_TYPE.TIME,
          required: true,
          error: '',
          step: 900,
        },
        {
          key: 'restTime',
          name: '休憩時間',
          type: INPUT_TYPE.TIME,
          required: true,
          error: '',
          step: 900,
        },
        {
          key: 'cutoffDayType',
          name: '勤怠締め日',
          type: INPUT_TYPE.SELECT,
          required: true,
          error: '',
          options: NOCArray.CUTOFFDAY,
        },
        {
          key: 'cutoffDay',
          name: '',
          type: INPUT_TYPE.NUMBER,
          required: false,
          error: '',
          min: 1,
          max: 28,
        },
        {
          key: 'weekFirst',
          name: '週の起算日',
          type: INPUT_TYPE.RADIO,
          required: false,
          error: '',
          options: NOCArray.DAY_OF_WEEK,
        },
        {
          key: 'legalHoliday',
          name: '',
          type: INPUT_TYPE.SELECT,
          required: false,
          error: '',
          options: NOCArray.LEGAL_HOLIDAY,
        },
      ] as IVariableInput[],
      itemCustomHoliday: {
        key: 'name',
        name: '',
        type: INPUT_TYPE.TEXT,
        required: true,
        error: '',
        max: 15,
      } as IVariableInput,
      mode: '',
      searchSideList: '',
      registCount: 0,
      migrateShowFlag: false,
      deleteHolidayItemShowFlag: false,
      isDefault: false, // SP初期表示時はdefault:true
      exclusionDepartmentShowFlag: false,
      DatePickerDateMD: 'M月d日',
      DatePickerDate: 'yyyy年M月d日',
      ja,
      formDataChangeFlgModal: false,
      isCheckExcludeFlag: false,
      isCheckMoveFlag: false,
      isCheckAllExcludeFlag: false,
      isCheckAllMoveFlag: false,
      isProcessing: false, // 二重サブミット防止用
      itemsPerPage: 10,
      viewPages: 1,
      searchWord: '',
    };
  },
  directives: {
    DatePicker,
  },
  computed: {
    searchDatas(): models.IWorkstyleUser[] {
      const lowerKeyword = this.searchWord.toLowerCase();
      return this.selectDispWorkstyleUsers.filter(item =>
        Object.values(item).some(value => {
          if (typeof value === 'string') {
            return value.toLowerCase().includes(lowerKeyword);
          }
          return false;
        }),
      );
    },
    paginatedDatas(): models.IWorkstyleUser[] {
      const start = (this.viewPages - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.searchDatas.slice(start, end);
    },
    MODE_NORMAL(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NORMAL);
    },
    MODE_SELECT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.SELECT);
    },
    // Group.vueに合わせてユーザー一覧編集用に使用
    MODE_EDIT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.EDIT);
    },
    MODE_NEW(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NEW);
    },
    MODE_NEW_NEXT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NEW_NEXT);
    },
    // MODE_CHARGE(): boolean {
    //   return this.checkMode(NOC.SETTING.MODE.CHARGE);
    // },
    MODE_EDIT_BASE(): boolean {
      return this.checkMode(NOC.SETTING.MODE.EDIT_BASE);
    },
    // 画面表示用
    SIDE_LIST(): IDispWorkstyle[] {
      const dsipWorkstyles = this.workstyles.filter(
        (v: models.IWorkstyle) => v.name.indexOf(this.searchSideList) >= 0,
      );

      // 増幅処理
      /*
      dsipWorkstyles = dsipWorkstyles.concat(dsipWorkstyles);
      dsipWorkstyles = dsipWorkstyles.concat(dsipWorkstyles);
      dsipWorkstyles = dsipWorkstyles.concat(dsipWorkstyles);
      dsipWorkstyles = dsipWorkstyles.concat(dsipWorkstyles);
      */

      // 表示する就業形態を表示用に修正
      return dsipWorkstyles.map(val => {
        // 週の起算日
        const weekFirst = NOCArray.DAY_OF_WEEK.find(
          v => v.value === val.weekFirst,
        );
        // 1年の起算日
        const yearFirstDate = new Date(val.yearFirst);
        const yearFirst = isNaN(yearFirstDate.getTime())
          ? '未設定'
          : `${yearFirstDate.getMonth() + 1}月${yearFirstDate.getDate()}日`;
        // カスタム日付
        const holiday = val.holiday; // .join(', ');
        /*
        const count = this.customHolidayUseds
          .filter((useds: models.ICustomHolidayUsed) => (useds.workstyleID === val.workstyleID));
        if (count.length > 0) {
          holiday += holiday.length > 0 ? ', ' : '';
          holiday += 'カスタム休日';
        }
        */

        // 休暇区分
        const useSpecialLeaveID = this.specialLeaveUseds
          .filter(
            (useds: models.ISpecialLeaveUsed) =>
              useds.workstyleID === val.workstyleID,
          )
          .map(v => v.specialLeaveID);
        const specialLeave = this.specialLeaves.filter(v =>
          useSpecialLeaveID.includes(v.specialLeaveID),
        );

        // カスタム休日
        const useCustomHolidyID = this.customHolidayUseds
          .filter(
            (useds: models.ICustomHolidayUsed) =>
              useds.workstyleID === val.workstyleID,
          )
          .map(v => v.customHolidayID);
        const customHoliday = this.customHolidays
          .filter(v => useCustomHolidyID.includes(v.customHolidayID))
          .map(v => {
            const dateStr = moment.fncChangeStringToJPFormatNonZero(v.date);
            return {
              name: v.name,
              date: v.everyYear ? '毎年' + dateStr.substr(5, 6) : dateStr,
            };
          });
        // 法定休日
        const legalHoliday = NOCArray.LEGAL_HOLIDAY.find(
          v => v.value === val.legalHoliday,
        );
        return {
          name: val.name,
          workTime:
            val.startTime.slice(0, 5) + ' 〜 ' + val.endTime.slice(0, 5),
          restTime: val.restTime.slice(0, 5),
          holiday,
          cutoffDay: val.cutoffDay,
          weekFirst: weekFirst ? weekFirst.text + '曜日' : '未設定',
          yearFirst,
          legalHoliday: legalHoliday
            ? legalHoliday.text
            : NOC.SETTING.LEGALHOLIDAY.ONE,
          specialLeave,
          customHoliday,
          workstyleID: val.workstyleID,
          workstyle: val,
        } as IDispWorkstyle;
      });
    },
    CUTOFFDAY_LAST(): number {
      return NOC.SETTING.CUTOFFDAY.VALUE.LAST;
    },
    DAY_OF_WEEK() {
      return NOCArray.DAY_OF_WEEK;
    },
    DAY_OF_WEEK_HOLIDAY(): string[] {
      return [
        NOC.SETTING.HOLIDAY.MON,
        NOC.SETTING.HOLIDAY.TUE,
        NOC.SETTING.HOLIDAY.WED,
        NOC.SETTING.HOLIDAY.THU,
        NOC.SETTING.HOLIDAY.FRI,
        NOC.SETTING.HOLIDAY.SAT,
        NOC.SETTING.HOLIDAY.SUN,
        NOC.SETTING.HOLIDAY.JAPAN,
      ];
    },
    CUTOFFDAY_SELECT(): number {
      return NOC.SETTING.CUTOFFDAY.VALUE.SELECT;
    },
    CUTOFFDAY() {
      return NOCArray.CUTOFFDAY;
    },
    LEGAL_HOLIDAY() {
      return NOCArray.LEGAL_HOLIDAY;
    },
    isCheckExclude(): boolean {
      const ExcludeValues = [];
      let count = 0;
      for (const i of this.userItemCurrentDep) {
        count += 1;
        if (i.checked) {
          ExcludeValues.push(i.checked);
        }
      }

      if (ExcludeValues.length === 0) {
        this.isCheckExcludeFlag = false;
        this.isCheckAllExcludeFlag = false;
      } else if (ExcludeValues.length === count) {
        this.isCheckExcludeFlag = true;
        this.isCheckAllExcludeFlag = true;
      } else {
        this.isCheckExcludeFlag = true;
        this.isCheckAllExcludeFlag = false;
      }

      return this.isCheckExcludeFlag || this.isCheckAllExcludeFlag;
    },
    isCheckMove(): boolean {
      const MoveValues = [];
      let count = 0;
      for (const i of this.userItemOtherDep) {
        count += 1;
        if (i.checked) {
          MoveValues.push(i.checked);
        }
      }

      if (MoveValues.length === 0) {
        this.isCheckMoveFlag = false;
        this.isCheckAllMoveFlag = false;
      } else if (MoveValues.length === count) {
        this.isCheckMoveFlag = true;
        this.isCheckAllMoveFlag = true;
      } else {
        this.isCheckMoveFlag = true;
        this.isCheckAllMoveFlag = false;
      }
      return this.isCheckMoveFlag || this.isCheckAllMoveFlag;
    },
    isShowModalDeleteHolidayItem(): boolean {
      return this.delTargetHolidayItem !== null;
    },
  },
  async mounted() {
    // データを取得
    this.mode = NOC.SETTING.MODE.CHARGE;
    this.$emit('pushPath', this.$route.path);
    const query = this.$route.query;
    const api = new API();
    const res = await api.get<models.VWorkstyle>('workstyle');
    // console.log(this.selectDispWorkstyle);
    // 成功時データ設定
    if (res.result) {
      this.workstyles = res.data.workstyles;
      this.specialLeaves = res.data.specialLeaves;
      this.specialLeaveUseds = res.data.specialLeaveUseds;
      this.customHolidays = res.data.customHolidays;
      this.customHolidayUseds = res.data.customHolidayUseds;
      this.mode = NOC.SETTING.MODE.NORMAL;
      if (query && query.md) {
        // ハンバーガーメニューから遷移してきた場合、サイドバー(SP)を初期表示する
        this.isDefault = true;
        // URLをクエリなしに書き換え
        this.$router.replace('/setting/work_style');
      }
    } else {
      this.$emit('change', NOC.APP.MODE.LOGIN);
    }
    // this.$emit('pushPath', this.$route.path);
    // 初期表示のリストの先頭ユーザーを表示
    await this.onSelectSideList(this.SIDE_LIST[0]);

    // 読み込み完了
    this.onload = true;
  },
  methods: {
    changeView(page: number) {
      this.$data.viewPages = page;
    },
    // モード判定
    checkMode(mode: string) {
      return this.mode === mode;
    },
    getItemID(v: models.IWorkstyle) {
      return v.workstyleID;
    },
    getItemText(v: models.IWorkstyle) {
      return v.name;
    },
    // サイドバー項目選択処理
    async onSelectSideList(dispWorkstyle: IDispWorkstyle) {
      // if (this.checkMode(NOC.SETTING.MODE.EDIT) || this.checkMode(NOC.SETTING.MODE.NEW)) {
      //  return;
      // }
      // 対象ユーザーリスト表示
      const api = new API();
      const resUsers = await api.get<models.VUsersList>('workstyle/users', {
        workstyleID: dispWorkstyle.workstyleID,
      });
      if (resUsers.result) {
        this.selectDispWorkstyleUsers = resUsers.data.users;
      }
      this.selectDispWorkstyle = dispWorkstyle;
      this.mode = NOC.SETTING.MODE.SELECT;
    },
    // サイドバークラス項目処理
    // classSideListActiveData(dispWorkstyle: IDispWorkstyle) {
    //   return {
    //     active : this.selectDispWorkstyle.workstyleID === dispWorkstyle.workstyleID,
    //   };
    // },
    onChange(value: any, item: validation.IPValidation) {
      validation.checkValue(value, item);
      this.customHolidays.splice(0, 0); // カスタム休日の変更検知用
    },
    // 新規ボタン押下時処理
    onClickNew() {
      window.scrollTo(0, 0);
      this.editWorkstyle = new models.CWorkstyle();
      this.mode = NOC.SETTING.MODE.NEW;
    },
    // 次へボタン押下時処理
    onClickNext() {
      window.scrollTo(0, 0);
      let cd = this.cutoffDayType;
      this.cutoffDayError = '';
      let flag = false;

      // 日付選択の場合はその値を取得
      if (cd === NOC.SETTING.CUTOFFDAY.VALUE.SELECT) {
        this.cutoffDay = Number(this.cutoffDay);
        if (1 > this.cutoffDay || this.cutoffDay >= 29) {
          // return;
          this.cutoffDayError = '1～28の範囲で入力してください。';
          flag = true;
        }
        cd = this.cutoffDay;
      }
      this.editWorkstyle.cutoffDay = cd;
      // validation
      if (cd === NOC.SETTING.CUTOFFDAY.VALUE.LAST) {
        if (
          validation.checkValues(this.editWorkstyle, this.items.slice(0, 3)) > 0
        ) {
          // return;
          flag = true;
        }
      } else {
        if (validation.checkValues(this.editWorkstyle, this.items) > 0) {
          // return;
          flag = true;
        }
      }
      this.items.filter(
        (x: IVariableInput) => x.key === 'cutoffDay',
      )[0].error = this.cutoffDayError;

      const startTime = Number(
        this.editWorkstyle.startTime
          .split(':')
          .slice(0, 2)
          .join(''),
      );
      const endTime = Number(
        this.editWorkstyle.endTime
          .split(':')
          .slice(0, 2)
          .join(''),
      );
      const restTime = Number(
        this.editWorkstyle.restTime
          .split(':')
          .slice(0, 2)
          .join(''),
      );

      // if (startTime < endTime) {
      //  this.items.filter((x: IVariableInput) => x.key === 'endTime')[0].error = '始業時間よりも早く設定されています。';
      //  return;
      // }
      if (startTime === endTime) {
        this.items.filter(
          (x: IVariableInput) => x.key === 'startTime',
        )[0].error = '始業時間が終業時間と同じです。';
        // return;
        flag = true;
      }

      if (startTime < endTime) {
        if (endTime - startTime - restTime <= 0) {
          this.items.filter(
            (x: IVariableInput) => x.key === 'startTime',
          )[0].error = '就業時間が0以下です。';
          // return;
          flag = true;
        }
      } else {
        if (endTime + 2400 - (startTime + restTime) <= 0) {
          this.items.filter(
            (x: IVariableInput) => x.key === 'startTime',
          )[0].error = '就業時間が0以下です。';
          // return;
          flag = true;
        }
      }
      if (flag) {
        return;
      }

      this.mode = NOC.SETTING.MODE.NEW_NEXT;
      window.scrollTo(0, 0);
      this.setAllUserList(0); // チェックボックスの選択なし
    },
    // キャンセルボタン押下時処理
    onClickCancel() {
      window.scrollTo(0, 0);
      this.selectDispWorkstyle = {} as IDispWorkstyle;
      this.editWorkstyle = {} as models.IWorkstyle;
      this.mode = NOC.SETTING.MODE.NORMAL;
    },
    // 登録ボタン押下時処理
    async onClickRegist() {
      window.scrollTo(0, 0);
      // 値の設定
      let cd = this.cutoffDayType;
      this.cutoffDayError = '';
      let flag = false;

      // 日付選択の場合はその値を取得
      if (cd === NOC.SETTING.CUTOFFDAY.VALUE.SELECT) {
        this.cutoffDay = Number(this.cutoffDay);
        if (1 > this.cutoffDay || this.cutoffDay >= 29) {
          // return;
          this.cutoffDayError = '1～28の範囲で入力してください。';
          flag = true;
        }
        cd = this.cutoffDay;
      }
      this.editWorkstyle.cutoffDay = cd;
      // validation
      if (cd === NOC.SETTING.CUTOFFDAY.VALUE.LAST) {
        if (
          validation.checkValues(this.editWorkstyle, this.items.slice(0, 3)) > 0
        ) {
          // return;
          flag = true;
        }
      } else {
        if (validation.checkValues(this.editWorkstyle, this.items) > 0) {
          // return;
          flag = true;
        }
      }
      this.items.filter(
        (x: IVariableInput) => x.key === 'cutoffDay',
      )[0].error = this.cutoffDayError;

      const startTime = Number(
        this.editWorkstyle.startTime
          .split(':')
          .slice(0, 2)
          .join(''),
      );
      const endTime = Number(
        this.editWorkstyle.endTime
          .split(':')
          .slice(0, 2)
          .join(''),
      );
      const restTime = Number(
        this.editWorkstyle.restTime
          .split(':')
          .slice(0, 2)
          .join(''),
      );

      // if (startTime < endTime) {
      //  this.items.filter((x: IVariableInput) => x.key === 'endTime')[0].error = '始業時間よりも早く設定されています。';
      //  return;
      // }
      if (startTime === endTime) {
        this.items.filter(
          (x: IVariableInput) => x.key === 'startTime',
        )[0].error = '始業時間が終業時間と同じです。';
        // return;
        flag = true;
      }

      if (startTime < endTime) {
        if (endTime - startTime - restTime <= 0) {
          this.items.filter(
            (x: IVariableInput) => x.key === 'startTime',
          )[0].error = '就業時間が0以下です。';
          // return;
          flag = true;
        }
      } else {
        if (endTime + 2400 - (startTime + restTime) <= 0) {
          this.items.filter(
            (x: IVariableInput) => x.key === 'startTime',
          )[0].error = '就業時間が0以下です。';
          // return;
          flag = true;
        }
      }
      if (flag) {
        return;
      }

      // 出力データ設定
      const editData: models.VPostWorkStyle = {
        workstyle: this.editWorkstyle,
        specialLeaveUseds: this.editSpecialLeaveUseds,
        customHolidayUseds: this.editCustomHolidayUseds,
        userIDs: this.editUsers.filter(v => v.checked).map(v => v.userID),
      };
      await this.registWorkstyle(editData);
    },
    // ユーザーのworkstyleIDのみを更新
    async onClickUpdate() {
      const api = new API();

      const requestData: models.VUpdateWorkstyleIDs = {
        currentusers: this.userItemCurrentDep,
        otherusers: this.userItemOtherDep,
      };
      const res = await api.put<models.VUpdateWorkstyleIDs, boolean>(
        'workstyle/update/userworkstyle',
        requestData,
      );

      this.mode = NOC.SETTING.MODE.NORMAL;
      this.onSelectSideList(this.selectDispWorkstyle);
    },
    // 就業規約 登録処理
    async registWorkstyle(requestData: models.VPostWorkStyle) {
      // validationは別vueで行われる
      this.isProcessing = true;
      const api = new API();
      let res;
      const nowMode = this.mode;

      if (this.checkMode(NOC.SETTING.MODE.NEW_NEXT)) {
        // 新規登録
        res = await api.post<models.VPostWorkStyle, models.VWorkstyle>(
          'workstyle/new',
          requestData,
        );
      } else {
        // 更新
        res = await api.put<models.VPostWorkStyle, models.VWorkstyle>(
          'workstyle/edit',
          requestData,
        );
      }

      // console.log('res', res);
      if (res.result) {
        this.workstyles = res.data.workstyles;
        this.specialLeaveUseds = res.data.specialLeaveUseds;
        this.customHolidayUseds = res.data.customHolidayUseds;
        this.selectBack();
        let selectData;
        selectData = this.workstyles.find(
          v => v.workstyleID === this.selectDispWorkstyle.workstyleID,
        );
        // console.log('selectData', selectData)
        if (selectData && this.workstyles.length > 0) {
          if (nowMode === NOC.SETTING.MODE.NEW_NEXT) {
            this.onSelectSideList(this.SIDE_LIST[this.SIDE_LIST.length - 1]);
          } else {
            let selectDataIndex;
            selectDataIndex = this.workstyles.findIndex(
              v => v.workstyleID === this.selectDispWorkstyle.workstyleID,
            );
            this.onSelectSideList(this.SIDE_LIST[selectDataIndex]);
          }
        }
      } else {
        // account参照
        this.$emit('info', '登録できませんでした。');
        this.isProcessing = false;
      }
    },
    // ユーザーを移行して削除する
    async deleteWorkStyle(workstyleID: number) {
      // ユーザーをworkstyleIDのworkstyleに移行する
      const api = new API();
      const userIDs = [];
      for (let _ = 0; _ < this.selectDispWorkstyleUsers.length; _++) {
        userIDs.push(this.selectDispWorkstyleUsers[_].userID);
      }
      const requestData: models.VTransitionUsers = {
        workstyleID,
        userIDs,
      };
      const res = await api.put<models.VTransitionUsers, boolean>(
        'workstyle/users/transition',
        requestData,
      );
      // Workstyleを削除する
      this.onClickDelete();
    },
    // 就業形態削除処理
    async onClickDelete() {
      window.scrollTo(0, 0);
      const workstyleID = this.selectDispWorkstyle.workstyleID;
      const api = new API();
      const res = await api.delete<models.VWorkstyle>('workstyle/delete', {
        deleteID: workstyleID,
      });
      if (res.result) {
        this.workstyles = res.data.workstyles;
        this.specialLeaveUseds = res.data.specialLeaveUseds;
        this.customHolidayUseds = res.data.customHolidayUseds;
        this.onClickCancel();
        this.onSelectSideList(this.SIDE_LIST[0]);
        this.isDefault = true;
      } else {
        this.$emit('info', '削除できませんでした。');
      }
    },
    // 現在の就業形態へ移動する
    moveUserToCurrentDep() {
      const checkedUsers = this.editUsers.filter(v => v.checked);
      for (const user of checkedUsers) {
        const idx = this.userItemOtherDep.findIndex(
          v => v.userID === user.userID,
        );
        if (idx > -1) {
          const item = this.userItemOtherDep[idx];
          item.workstyleID = this.selectDispWorkstyle.workstyleID;
          item.checked = false;
          user.checked = false;
          this.userItemCurrentDep.push(item);
          this.userItemOtherDep.splice(idx, 1);
        }
      }
      // console.log(this.editUsers, checkedUsers);
    },
    // 現在の就業形態から除外する
    moveUserToOtherDep(workstyleID: number) {
      const targetWorkstyle = this.workstyles.find(
        v => v.workstyleID === workstyleID,
      );
      const workstyleName = targetWorkstyle ? targetWorkstyle.name : '';
      const checkedUsers = this.editUsers.filter(v => v.checked);
      for (const user of checkedUsers) {
        const idx = this.userItemCurrentDep.findIndex(
          v => v.userID === user.userID,
        );
        if (idx > -1) {
          const item = this.userItemCurrentDep[idx];
          item.workstyleID = workstyleID;
          item.workstyle = workstyleName;
          item.checked = false;
          user.checked = false;
          this.userItemOtherDep.push(item);
          this.userItemCurrentDep.splice(idx, 1);
        }
      }
      // console.log(this.editUsers, checkedUsers);
    },
    // 休暇区分 新規作成処理
    onClickNewSpecialLeave() {
      this.newSpecialLeave = new models.CSpecialLeave();
      this.newSpecialLeave.validItem = JSON.parse(
        JSON.stringify(this.itemCustomHoliday),
      );
      this.newSpecialLeave.editData = new models.CSpecialLeave();
      this.newSpecialLeave.editData.validItem = JSON.parse(
        JSON.stringify(this.itemCustomHoliday),
      );
    },
    // カスタム休日 新規作成処理
    onClickNewCustomHoliday() {
      this.newCustomHoliday = new models.CCustomHoliday();
      this.newCustomHoliday.validItem = JSON.parse(
        JSON.stringify(this.itemCustomHoliday),
      );
      this.newCustomHoliday.editData = new models.CCustomHoliday();
      this.newCustomHoliday.editData.validItem = JSON.parse(
        JSON.stringify(this.itemCustomHoliday),
      );
    },
    onClickEditHolidayItem(holidayItem: HolidayItem, array: HolidayItem[]) {
      // window.scrollTo(0, 0);
      holidayItem.editData = JSON.parse(JSON.stringify(holidayItem));
      holidayItem.validItem = JSON.parse(
        JSON.stringify(this.itemCustomHoliday),
      );
      holidayItem.editData!.editData = null;
      array.splice(0, 0); // 変更反映
    },
    onClickEditCancelHolidayItem(
      holidayItem: HolidayItem,
      array: HolidayItem[],
    ) {
      holidayItem.editData = null;
      holidayItem.validItem = null;
      array.splice(0, 0); // 変更反映
    },
    // 休暇区分 登録処理
    async onClickRegistSpecialLeave(
      specialLeave: models.ISpecialLeave,
      validItem: validation.IPValidation,
    ) {
      // 入力チェック
      if (validation.checkValue(specialLeave.name, validItem)) {
        return;
      }

      let result = false;
      // idの有無によって処理を変更
      if (specialLeave.specialLeaveID === 0) {
        result = await this.registSpecialLeave(specialLeave);
      } else {
        result = await this.editSpecialLeave(specialLeave);
      }
      // 問題なく更新できた場合閉じる
      if (result) {
        this.newSpecialLeave = null;
      }
    },
    // カスタム休日 登録処理
    async onClickRegistCustomHoliday(
      customHoliday: models.ICustomHoliday,
      validItem: validation.IPValidation,
    ) {
      // 入力チェック
      if (validation.checkValue(customHoliday.name, validItem)) {
        return;
      }

      customHoliday.date = moment.fncChangeStringToJPFormatNonZero(
        customHoliday.date,
      );
      let result = false;
      // idの有無によって処理を変更
      if (customHoliday.customHolidayID === 0) {
        result = await this.registCustomHoliday(customHoliday);
      } else {
        result = await this.editCustomHoliday(customHoliday);
      }
      // 問題なく更新できた場合閉じる
      if (result) {
        this.newCustomHoliday = null;
      }
    },
    // カスタム休日 削除処理
    // async onClickDeleteCustomHoliday(customHoliday: models.ICustomHoliday) {
    //   this.delTargetCustomHoliday = customHoliday;
    //   const customHolidayID = this.delTargetCustomHoliday.customHolidayID;
    //   const useCustomHoliday = this.customHolidayUseds.filter((v) => (v.customHolidayID === customHolidayID));
    //   if (useCustomHoliday.length > 0) {
    //     this.$emit('info', '使用中のカスタム日付のため削除できませんでした。');
    //     return false;
    //   }
    //   const api = new API();
    //   const res = await api.delete<models.VWorkstyle>('workstyle/customholiday/delete', {deleteID: customHolidayID});
    //   if (res.result) {
    //     this.customHolidays = res.data.customHolidays;
    //     // this.$emit('info', '削除しました。');
    //   } else {
    //     this.$emit('info', '削除できませんでした。');
    //     return false;
    //   }
    //   return true;
    // },
    // カスタム休日 新規登録処理
    async registSpecialLeave(
      requestData: models.ISpecialLeave,
    ): Promise<boolean> {
      const api = new API();
      const res = await api.post<models.ISpecialLeave, models.VWorkstyle>(
        `workstyle/specialleave/new`,
        requestData,
      );
      if (res.result) {
        this.specialLeaves = res.data.specialLeaves;
      } else {
        this.$emit('info', '登録できませんでした。');
        return false;
      }
      return true;
    },
    // カスタム休日 新規登録処理
    async registCustomHoliday(
      requestData: models.ICustomHoliday,
    ): Promise<boolean> {
      const api = new API();
      const res = await api.post<models.ICustomHoliday, models.VWorkstyle>(
        `workstyle/customholiday/new`,
        requestData,
      );
      if (res.result) {
        this.customHolidays = res.data.customHolidays;
      } else {
        this.$emit('info', '登録できませんでした。');
        return false;
      }
      return true;
    },
    // 休暇区分 編集処理
    async editSpecialLeave(
      requestData: models.ISpecialLeave,
    ): Promise<boolean> {
      const api = new API();
      const res = await api.put<models.ISpecialLeave, models.VWorkstyle>(
        `workstyle/specialleave/edit`,
        requestData,
      );
      if (res.result) {
        this.specialLeaves = res.data.specialLeaves;
      } else {
        this.$emit('info', '登録できませんでした。');
        return false;
      }
      return true;
    },
    // カスタム休日 編集処理
    async editCustomHoliday(
      requestData: models.ICustomHoliday,
    ): Promise<boolean> {
      const api = new API();
      const res = await api.put<models.ICustomHoliday, models.VWorkstyle>(
        `workstyle/customholiday/edit`,
        requestData,
      );
      if (res.result) {
        this.customHolidays = res.data.customHolidays;
      } else {
        this.$emit('info', '登録できませんでした。');
        return false;
      }
      return true;
    },
    // 休暇区分 削除処理
    async deleteSpecialLeave(id: number): Promise<boolean> {
      const useCustomHoliday = this.specialLeaveUseds.filter(
        v => v.specialLeaveID === id,
      );
      if (useCustomHoliday.length > 0) {
        this.$emit('info', '使用中の休暇区分のため削除できませんでした。');
        return false;
      }
      const api = new API();
      const res = await api.delete<models.VWorkstyle>(
        'workstyle/specialleave/delete',
        { deleteID: id },
      );
      if (res.result) {
        this.specialLeaves = res.data.specialLeaves;
        this.$emit('info', '削除しました。');
      } else {
        this.$emit('info', '削除できませんでした。');
        return false;
      }
      // }
      return true;
    },
    // カスタム休日 削除処理
    async deleteCustomHoliday(id: number): Promise<boolean> {
      // if (await this.confirmDialog(name + ' を削除してよろしいですか？')) {
      const useCustomHoliday = this.customHolidayUseds.filter(
        v => v.customHolidayID === id,
      );
      if (useCustomHoliday.length > 0) {
        this.$emit('info', '使用中のカスタム日付のため削除できませんでした。');
        return false;
      }
      const api = new API();
      const res = await api.delete<models.VWorkstyle>(
        'workstyle/customholiday/delete',
        { deleteID: id },
      );
      if (res.result) {
        this.customHolidays = res.data.customHolidays;
        this.$emit('info', '削除しました。');
      } else {
        this.$emit('info', '削除できませんでした。');
        return false;
      }
      // }
      return true;
    },
    fncChangeStringToJPFormatNonZero(date: string) {
      return moment.fncChangeStringToJPFormatNonZero(date);
    },
    // 削除
    migrateDelete() {
      this.setAllUserList(this.selectDispWorkstyle.workstyleID);
      this.migrateShowFlag = true;
    },
    closeModal() {
      this.migrateShowFlag = false;
    },
    showDeleteModalSpecialLeave(specialLeave: models.ISpecialLeave) {
      this.delTargetHolidayItem = specialLeave;
      this.delTargetCallBack = () =>
        this.deleteSpecialLeave(specialLeave.specialLeaveID);
    },
    showDeleteModalCustomHoliday(customHoliday: models.ICustomHoliday) {
      this.delTargetHolidayItem = customHoliday;
      this.delTargetCallBack = () =>
        this.deleteCustomHoliday(customHoliday.customHolidayID);
    },
    // 編集データ作成
    setEditData() {
      // 締め日を設定
      const cd = this.editWorkstyle.cutoffDay;
      if (NOCArray.checkOptionsText(NOCArray.CUTOFFDAY, cd)) {
        this.cutoffDayType = cd;
      } else {
        this.cutoffDayType = NOC.SETTING.CUTOFFDAY.VALUE.SELECT;
        this.cutoffDay = cd;
      }
      // 入力エラーリセット
      for (const item of this.items) {
        item.error = '';
      }
      // カスタム休日編集データリセット
      for (const day of this.customHolidays) {
        day.editData = null;
        if (day.validItem) {
          day.validItem.error = '';
        }
      }
      this.newSpecialLeave = null;
      this.newCustomHoliday = null;
    },
    // 基本情報の編集ボタン押下時処理
    onClickEditBase() {
      window.scrollTo(0, 0);
      this.editWorkstyle = JSON.parse(
        JSON.stringify(this.selectDispWorkstyle.workstyle),
      );
      this.compEditWorkstyle = JSON.parse(
        JSON.stringify(this.selectDispWorkstyle.workstyle),
      );

      // 休暇区分設定
      this.editSpecialLeaveUseds = JSON.parse(
        JSON.stringify(
          this.specialLeaveUseds.filter(
            (v: models.ISpecialLeaveUsed) =>
              v.workstyleID === this.editWorkstyle.workstyleID,
          ),
        ),
      );

      // カスタム休日設定
      this.editCustomHolidayUseds = JSON.parse(
        JSON.stringify(
          this.customHolidayUseds.filter(
            (v: models.ICustomHolidayUsed) =>
              v.workstyleID === this.editWorkstyle.workstyleID,
          ),
        ),
      );
      this.mode = NOC.SETTING.MODE.EDIT_BASE;

      // 新規・編集共通の初期化処理
      this.setEditData();
    },
    // 対象ユーザーの編集ボタン押下時処理
    async onClickEditUser() {
      this.mode = NOC.SETTING.MODE.EDIT;
      window.scrollTo(0, 0);
      await this.setAllUserList(this.selectDispWorkstyle.workstyleID);
    },
    // 戻る
    selectBack() {
      window.scrollTo(0, 0);
      this.mode = NOC.SETTING.MODE.SELECT;
      this.isDefault = false;
    },
    // 戻る
    selectBackNew() {
      window.scrollTo(0, 0);
      this.mode = NOC.SETTING.MODE.NEW;
      this.isDefault = false;
    },
    // 戻る（SP時サイドバーメニュー表示）
    selectBackMenu() {
      window.scrollTo(0, 0);
      this.mode = NOC.SETTING.MODE.SELECT;
      this.isDefault = true;
    },
    // 就業形態を追加
    addWorkstyle() {
      window.scrollTo(0, 0);
      this.editWorkstyle = new models.CWorkstyle();
      this.compEditWorkstyle = new models.CWorkstyle();
      this.editSpecialLeaveUseds = [];
      this.editCustomHolidayUseds = [];
      this.setEditData();
      this.mode = NOC.SETTING.MODE.NEW;
    },
    // 絞り込むボタン押下時処理
    onClickFilter() {
      // console.log(this.inputedSearchWorkstyle)
      this.searchWorkstyle = this.inputedSearchWorkstyle;
      this.otherSearchWorkstyle = this.inputedSearchWorkstyle;
      this.searchName = this.inputedSearchName;
      this.otherSearchName = this.inputedSearchName;
    },
    onClickFilterBasicWork() {
      this.searchWorkstyle = this.inputedSearchWorkstyle;
      this.searchName = this.inputedSearchName;
    },
    onClickFilterOtherWork() {
      this.otherSearchWorkstyle = this.inputedSearchWorkstyle;
      this.otherSearchName = this.otherInputedSearchName;
    },

    // ユーザーリスト（チェックボックス付き）を設定
    async setAllUserList(workstyleID: number) {
      this.searchWorkstyle = 0;
      this.searchName = '';
      const api = new API();
      const resUsers = await api.get<models.VUsersList>('workstyle/users', {
        workstyleID,
        isGetAll: true,
      });
      // console.log(resUsers)
      if (resUsers.result) {
        this.editUsers = resUsers.data.users;
        for (const user of this.editUsers) {
          user.checked = false;
        }
        this.optionsWorkstyle = [NOC.SELECT.ALL_WORKSTYLES].concat(
          resUsers.data.workstyles,
        );
        this.migrateConfirmOptions = [NOC.SELECT.NOSELECT_LONG].concat(
          resUsers.data.workstyles.filter(v => v.value !== workstyleID),
        );
        this.optionsExclusionDepartment = resUsers.data.workstyles.filter(
          v => v.value !== workstyleID,
        );
      }
      // テーブル表示文字列(PC)
      this.tableItems = JSON.parse(JSON.stringify(this.editUsers));
      this.userItemCurrentDep = JSON.parse(
        JSON.stringify(
          this.editUsers.filter(
            v => v.workstyleID === this.selectDispWorkstyle.workstyleID,
          ),
        ),
      );
      this.userItemOtherDep = JSON.parse(
        JSON.stringify(
          this.editUsers.filter(
            v => v.workstyleID !== this.selectDispWorkstyle.workstyleID,
          ),
        ),
      );
      // ユーザー移動されているか比較用のコピー
      this.compUserItemCurrentDep = JSON.parse(
        JSON.stringify(
          this.editUsers.filter(
            v => v.workstyleID === this.selectDispWorkstyle.workstyleID,
          ),
        ),
      );
      for (const item of this.tableItems) {
        let user = `${item.sei} ${item.mei}`;
        if (item.mail) {
          user += ` (${item.mail})`;
        }
        item.user = user;
      }
      for (const item of this.userItemCurrentDep) {
        item.checked = false;
        item.user = `${item.sei} ${item.mei}`;
      }
      for (const item of this.userItemOtherDep) {
        item.user = `${item.sei} ${item.mei}`;
      }
      // テーブル表示文字列(メールアドレスなし)
      this.tableItemsHideEmail = JSON.parse(JSON.stringify(this.editUsers));
      for (const item of this.tableItemsHideEmail) {
        const user = `${item.sei} ${item.mei}`;
        item.user = user;
      }
    },
    filteringUser(row: any, filter: any) {
      const matchWorkstyle =
        !filter.workstyleID || row.workstyleID === filter.workstyleID;
      return (
        matchWorkstyle &&
        (!filter.userName || strFuzzyMatch(filter.userName, row.user))
      );
    },
    onCheckUser(data: any, checked: boolean) {
      for (const user of this.editUsers) {
        if (user.userID === data.userID) {
          user.checked = checked;
          break;
        }
      }
    },
    onCheckAllUser(checked: boolean) {
      for (const user of this.editUsers) {
        user.checked = checked;
      }
    },
    onCheckAllCurrentUser(checked: boolean) {
      for (const user of this.editUsers) {
        for (const i of this.userItemCurrentDep) {
          if (user.userID === i.userID) {
            user.checked = checked;
          }
        }
      }
    },
    onCheckAllOtherUser(checked: boolean) {
      // console.log(this.searchWorkstyle,this.userItemOtherDep);
      for (const user of this.editUsers) {
        for (const i of this.userItemOtherDep) {
          if (user.userID === i.userID) {
            user.checked = checked;
          }
        }
      }
    },
    formWorkstyleDataChange() {
      let editWorkstyleBaseDataChangeFlg = false;
      let customHolidayChangeFlg = false;
      if (
        this.editWorkstyle.name === this.compEditWorkstyle.name && // 就業形態名
        this.editWorkstyle.startTime === this.compEditWorkstyle.startTime && // 就業時間（始）
        this.editWorkstyle.endTime === this.compEditWorkstyle.endTime && // 就業時間（終）
        this.editWorkstyle.restTime === this.compEditWorkstyle.restTime && // 休憩時間
        this.cutoffDayType === 99 && // 勤怠締め日（初期は末日締めの99）
        Number(this.editWorkstyle.weekFirst) ===
          Number(this.compEditWorkstyle.weekFirst) && // 週の起算日
        this.editWorkstyle.yearFirst === this.compEditWorkstyle.yearFirst && // 1年の起算日
        this.editWorkstyle.holiday.length === 3 &&
        this.editWorkstyle.holiday[0] === '土' &&
        this.editWorkstyle.holiday[1] === '日' &&
        this.editWorkstyle.holiday[2] === '祝日' && // 休日の入力チェック（初期値を見て無理やりif文で合わせた）
        this.editSpecialLeaveUseds.length === 0 && // 休暇区分 カスタム休日と同様
        this.editCustomHolidayUseds.length === 0 && // カスタム休日の入力チェック（追加画面の初期は何も選択されていない状態なので、何も選択されていなければ（要素数が０なら）という定義とした）
        Number(this.editWorkstyle.legalHoliday) ===
          Number(this.compEditWorkstyle.legalHoliday) // 法定休日
      ) {
        editWorkstyleBaseDataChangeFlg = false;
      } else {
        editWorkstyleBaseDataChangeFlg = true;
      }

      customHolidayChangeFlg =
        this.checkCustomHolidayChange() || this.checkSpecialLeaveChange();

      if (editWorkstyleBaseDataChangeFlg || customHolidayChangeFlg) {
        // 編集ボタン押下後と差異があれば、編集中データのモーダルを表示する
        this.formDataChangeFlgModal = true;
      } else {
        this.formDataChangeFlgModal = false;
        if (this.MODE_NEW_NEXT) {
          // NEWかNEW_NEXTだけ来る前提
          this.selectBackNew();
        } else {
          this.selectBackMenu();
        }
      }
    },
    formWorkstyleBaseDataChange() {
      let editWorkstyleBaseDataChangeFlg = false;
      let customHolidayChangeFlg = false;
      // 編集ボタン押下時の修行携帯基本情報と比較
      // console.log(this.cutoffDay, this.compEditWorkstyle.cutoffDay);
      if (
        this.editWorkstyle.name === this.compEditWorkstyle.name && // 就業形態名
        this.editWorkstyle.startTime === this.compEditWorkstyle.startTime && // 就業時間（始）
        this.editWorkstyle.endTime === this.compEditWorkstyle.endTime && // 就業時間（終）
        this.editWorkstyle.restTime === this.compEditWorkstyle.restTime && // 休憩時間 // 締め日
        ((this.cutoffDayType === 1 &&
          Number(this.cutoffDay) ===
            Number(this.compEditWorkstyle.cutoffDay)) ||
          (this.cutoffDayType !== 1 &&
            this.cutoffDayType === this.compEditWorkstyle.cutoffDay)) &&
        Number(this.editWorkstyle.weekFirst) ===
          Number(this.compEditWorkstyle.weekFirst) && // 週の起算日
        this.editWorkstyle.yearFirst === this.compEditWorkstyle.yearFirst && // 1年の起算日
        this.editWorkstyle.holiday.length ===
          this.compEditWorkstyle.holiday.length && // 休日の選択数
        !this.editWorkstyle.holiday.some(
          (v, i) => v !== this.compEditWorkstyle.holiday[i],
        ) && // 休日の選択内容が異なるものが無いか
        this.editSpecialLeaveUseds.length === this.specialLeaveUseds.length && // カスタム休日の選択数
        this.editSpecialLeaveUseds.every(
          (v, i) =>
            v.specialLeaveID === this.specialLeaveUseds[i].specialLeaveID,
        ) && // カスタム休日の選択内容が異なるものが無いか
        this.editCustomHolidayUseds.length === this.customHolidayUseds.length && // カスタム休日の選択数
        this.editCustomHolidayUseds.every(
          (v, i) =>
            v.customHolidayID === this.customHolidayUseds[i].customHolidayID,
        ) && // カスタム休日の選択内容が異なるものが無いか
        Number(this.editWorkstyle.legalHoliday) ===
          Number(this.compEditWorkstyle.legalHoliday) // 法定休日
      ) {
        editWorkstyleBaseDataChangeFlg = false;
      } else {
        editWorkstyleBaseDataChangeFlg = true;
      }

      customHolidayChangeFlg =
        this.checkCustomHolidayChange() || this.checkSpecialLeaveChange();

      if (editWorkstyleBaseDataChangeFlg || customHolidayChangeFlg) {
        // 編集ボタン押下後と差異があれば、編集中データのモーダルを表示する
        this.formDataChangeFlgModal = true;
      } else {
        this.formDataChangeFlgModal = false;
        this.selectBackMenu();
      }
    },
    formDataUserChange() {
      let editUsersCheckFlg = false;
      let userItemCurrentDepFlg = false;
      // ユーザーのチェックボタンが押されているかどうか
      for (let i = 0; i < this.editUsers.length; i++) {
        if (Boolean(this.editUsers[i].checked) === false) {
          editUsersCheckFlg = false;
        } else {
          editUsersCheckFlg = true;
          break;
        }
      }
      // ユーザーの移動がされているか
      if (
        this.userItemCurrentDep.length === this.compUserItemCurrentDep.length
      ) {
        for (let i = 0; i < this.userItemCurrentDep.length; i++) {
          if (
            this.userItemCurrentDep[i].userID ===
            this.compUserItemCurrentDep[i].userID
          ) {
            userItemCurrentDepFlg = false;
          } else {
            userItemCurrentDepFlg = true;
            break;
          }
        }
      } else {
        userItemCurrentDepFlg = true;
      }

      if (editUsersCheckFlg || userItemCurrentDepFlg) {
        // 編集ボタン押下後と差異があれば、編集中データのモーダルを表示する
        this.formDataChangeFlgModal = true;
      } else {
        this.formDataChangeFlgModal = false;
        this.selectBackMenu();
      }
    },
    checkSpecialLeaveChange() {
      // 休暇区分の編集、新規作成の編集を検知する
      return (
        (this.newSpecialLeave != null && this.newSpecialLeave.isEdit()) ||
        this.specialLeaves.some(hc => hc.isEdit())
      );
    },
    checkCustomHolidayChange() {
      // カスタム休日の編集、新規作成の編集を検知する関数
      return (
        (this.newCustomHoliday != null && this.newCustomHoliday.isEdit()) ||
        this.customHolidays.some(ch => ch.isEdit())
      );
    },
  },
});
